import { c as _c } from "react/compiler-runtime";
import { LinkButton, LoadingSpinner, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type DecryptProps = {
  isDecryptable: boolean;
  isDecrypting: boolean;
  onClick: () => void;
};
const Decrypt = t0 => {
  const $ = _c(6);
  const {
    isDecryptable,
    isDecrypting,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.decrypt"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== isDecryptable || $[2] !== isDecrypting || $[3] !== onClick || $[4] !== t) {
    t2 = <div className="flex flex-wrap content-center gap-1 justify-center items-center w-full h-dvh px-4 text-center md:flex-nowrap md:px-0 md:text-start">{isDecrypting ? <LoadingSpinner /> : <><span className="text-body-2 text-primary">{t(_temp)}</span><Tooltip disabled={isDecryptable} content={t(_temp2)}><LinkButton disabled={!isDecryptable} onClick={onClick} className="mb-0.5">{t(_temp3)}</LinkButton></Tooltip><span className="text-body-2 text-primary-500">{t(_temp4)}</span></>}</div>;
    $[1] = isDecryptable;
    $[2] = isDecrypting;
    $[3] = onClick;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default Decrypt;
function _temp($) {
  return $.messageStart;
}
function _temp2($_0) {
  return $_0.notAllowed;
}
function _temp3($_1) {
  return $_1.decryptCta;
}
function _temp4($_2) {
  return $_2.messageEnd;
}